import * as types from "./mutation-types";
import api from "../../../core/http/axios";
import routes from "../../../core/config/api-ontick.routes";
import translateSymbol from "../translate-symbol";

export const setBests = async ({ commit }, payload) => {
  try {
    const account_id = payload;
    const { data } = await api.get(routes.LIST_BESTS, {
      params: { account_id },
    });
    let newData = {
      ...data,
      available_bests: data.available_bests?.map((item) => {
        return {
          ...item,
          label: translateSymbol(item.best_symbol),
        };
      }),
      user_bests: data.user_bests?.map((item) => {
        return {
          ...item,
          label: translateSymbol(item.bo_symbol),
        };
      }),
    };
    commit(types.SET_BESTS, newData);
  } catch (err) {
    console.error(err);
  }
};

export const setBestsHistory = async ({ commit }, payload) => {
  try {
    const { account_id, page } = payload;
    const { data } = await api.get(routes.GET_BESTS_HISTORY, {
      params: {
        account_id,
        page,
      },
    });

    let newData = data.bests_history.map((item) => {
      return {
        ...item,
        label: translateSymbol(item.bo_symbol),
      };
    });

    commit(types.SET_BESTS_HISTORY, newData);
    return data;
  } catch (err) {
    // console.error(err);
  }
};

export const updateBest = async ({ commit, state, rootGetters }, payload) => {
  const { bo_id, bo_symbol, bo_direction, bo_entry_price } = payload;
  const symbol_price = rootGetters["marketdata/getSymbolPrice"](bo_symbol);

  let new_pnl;
  if (bo_direction === "BUY") {
    new_pnl = symbol_price - bo_entry_price;
  } else {
    new_pnl = bo_entry_price - symbol_price;
  }

  if (symbol_price == null) {
    new_pnl = null;
  }

  commit(types.UPDATE_BEST, {
    bo_id,
    new_pnl,
  });
};

export const closeBest = ({ commit }, payload) => {
  commit(types.CLOSE_BEST, payload);
};

export const removeBest = ({ commit }, payload) => {
  commit(types.REMOVE_BEST, payload);
};
